export default {
    "accountsAndCards": "Accounts and cards",
    "accounts": "Accounts",
    "paidAccount": "Account 1 %",
    "juniorAccount": "Junior Account",
    "cards": "Cards",
    "creditCard": "Credit card",
    "debitCard": "Debit card",
    "investment": "Investment",
    "weInvest": "We invest",
    "youInvest": "You invest",
    "investmentFund": "Investment funds",
    "indexPortfolio": "Index portfolio",
    "indexFunds": "Index dunds",
    "plusFunds": "Plus funds",
    "pensionPlans": "Pension plans",
    "mortgage": "Mortgage",
    "fixedMortgage": "Fixed mortgage",
    "variableMortgage": "Variable-Rate mortgage",
    "myInvestorMortgage": "Hipotecas MyInvestor",
    "tools": "Tools",
    "portfolioSimulator": "Portfolio simulator",
    "fundFinderShort": "Fund Finder",
    "fundFinder": "Fund Finder",
    "pensionSimulator": "Pension plan simulator",
    "pensionPlanFinder": "Pension plan finder",
    "newMortgageSimulator": "New mortgage simulator",
    "oldMortgageSimulator": "Old mortgage simulator",
    "julia": "Meet Julia",
    "signUp": "Sign up",
    "signIn": "Sign in",
    "insurance": "Insurance",
    "faqs": "Frequently Asked Questions"
};
